// Step 11d · add-on — the dashboard tables with adjustable columns: the locked colours of FdTable / Th (FdPrimitives.jsx) on
// the shared primitive (components/ui/resizable-table.jsx). The widths are px (were % of the panel), kept per browser; the
// table scrolls sideways inside its panel when the columns are wider than it, never the page.
import React from "react";
import { FD } from "./fdTheme";
import { ResizableTable, ResizableTh } from "@/components/ui/resizable-table";

export function FdResizableTable({ cols, children, testid, className = "", scroll = true }) {
  // ``scroll={false}``: the panel already has its own sideways-scroll box (staff time)
  return (
    <ResizableTable cols={cols} wrap={scroll} data-testid={testid} className={`w-full text-sm ${className}`}
                    style={{ borderCollapse: "separate", borderSpacing: 0 }}>
      {children}
    </ResizableTable>
  );
}

export function FdRTh({ index, children, className = "", align = "start", style }) {
  return (
    <ResizableTh index={index} className={`px-2 py-2 text-${align} text-xs font-semibold uppercase tracking-wide break-words ${className}`}
                 style={{ background: FD.thBg, color: FD.thText, borderBottom: `2px solid ${FD.thLine}`, ...style }}>
      {children}
    </ResizableTh>
  );
}
